import { DatasetGroup } from "api/model/dataset/datasetGroups";
import { TreeNode } from "primereact/treenode";
import { T } from "services/lang/LanguageService";

const formatGroupsOnUpdate = (
  groups: DatasetGroup[],
  newGroup: DatasetGroup,
  isDeletion: boolean = false
) => {
  if (!groups) return [];
  return groups.map((item): DatasetGroup => {
    if (item.id === newGroup?.parentId) {
      const group = item.children.find(c => c.id === newGroup.id);

      // Create new group
      if (!group)
        return {
          ...item,
          children: [...item.children, newGroup],
        };

      // Delete group
      if (isDeletion)
        return {
          ...item,
          children: item.children.filter(c => c.id !== newGroup.id),
        };

      // Update group
      return {
        ...item,
        children: item.children.map(c => (c.id === newGroup.id ? newGroup : c)),
      };
    }
    return {
      ...item,
      children: formatGroupsOnUpdate(item.children, newGroup, isDeletion),
    };
  });
};

const mapDatasetGroupsToTreeNodes = (datasetGroups: DatasetGroup[], key: string = ""): TreeNode[] => {
  if (datasetGroups.length === 0) return [];
  return datasetGroups.map((g, i) => mapDatasetGroupToTreeNode(g, `${key}${i}`));
};

const mapDatasetGroupToTreeNode = (datasetGroup: DatasetGroup, key: string = "0"): TreeNode => {
  return {
    key,
    label: datasetGroup.title || `(${T("word.no-title")})`,
    data: datasetGroup,
    children: mapDatasetGroupsToTreeNodes(datasetGroup.children, `${key}-`),
  };
};

export { formatGroupsOnUpdate, mapDatasetGroupsToTreeNodes };
